import { FC, useEffect } from 'react'
import { SelectInput } from 'src/components/UI'
import { SelectInputOption } from '../SelectInput/types'

// Popular Google Fonts list
const GOOGLE_FONTS: SelectInputOption[] = [
  { key: 'Open Sans', label: 'Open Sans' },
  { key: 'Roboto', label: 'Roboto' },
  { key: 'Lato', label: 'Lato' },
  { key: 'Montserrat', label: 'Montserrat' },
  { key: 'Oswald', label: 'Oswald' },
  { key: 'Source Sans Pro', label: 'Source Sans Pro' },
  { key: 'Raleway', label: 'Raleway' },
  { key: 'PT Sans', label: 'PT Sans' },
  { key: 'Merriweather', label: 'Merriweather' },
  { key: 'Nunito', label: 'Nunito' },
  { key: 'Playfair Display', label: 'Playfair Display' },
  { key: 'Poppins', label: 'Poppins' },
  { key: 'Ubuntu', label: 'Ubuntu' },
  { key: 'Mukta', label: 'Mukta' },
  { key: 'Rubik', label: 'Rubik' },
  { key: 'Work Sans', label: 'Work Sans' },
  { key: 'Roboto Condensed', label: 'Roboto Condensed' },
  { key: 'Noto Sans', label: 'Noto Sans' },
  { key: 'Fira Sans', label: 'Fira Sans' },
  { key: 'Quicksand', label: 'Quicksand' },
  { key: 'Karla', label: 'Karla' },
  { key: 'Cabin', label: 'Cabin' },
  { key: 'Barlow', label: 'Barlow' },
  { key: 'Arimo', label: 'Arimo' },
  { key: 'Titillium Web', label: 'Titillium Web' },
  { key: 'Varela Round', label: 'Varela Round' },
  { key: 'Inter', label: 'Inter' },
  { key: 'Archivo', label: 'Archivo' },
  { key: 'Heebo', label: 'Heebo' },
  { key: 'Asap', label: 'Asap' },
]

interface FontPickerProps {
  activeFontFamily?: string
  onChange: (font: { family: string }) => void
  pickerId?: string
}

const FontPicker: FC<FontPickerProps> = ({ activeFontFamily, onChange, pickerId }) => {
  // Load the selected font from Google Fonts
  useEffect(() => {
    if (activeFontFamily) {
      const fontUrl = `https://fonts.googleapis.com/css2?family=${activeFontFamily.replace(/ /g, '+')}&display=swap`
      const existingLink = document.querySelector(`link[href="${fontUrl}"]`)
      
      if (!existingLink) {
        const link = document.createElement('link')
        link.href = fontUrl
        link.rel = 'stylesheet'
        document.head.appendChild(link)
      }
    }
  }, [activeFontFamily])

  const selectedFont = GOOGLE_FONTS.find(font => font.key === activeFontFamily)

  return (
    <SelectInput
      options={GOOGLE_FONTS}
      value={selectedFont}
      onChange={(newSelected: SelectInputOption) => {
        onChange({ family: newSelected.key as string })
      }}
      sx={{
        '& .MuiSelect-select': {
          fontFamily: activeFontFamily || 'inherit',
        }
      }}
    />
  )
}

export default FontPicker
